import firebase from 'firebase/compat/app';
import { environment } from '../environments/environment';
import 'firebase/compat/messaging';

firebase.initializeApp(environment.firebaseConfig);

let messaging;

// Prevent crash on non-HTTPS environments or unsupported browsers
if (typeof window !== 'undefined' && 'serviceWorker' in navigator) {
  messaging = firebase.messaging();
}

export { messaging };
